import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ReviewService } from '../../services/review.service';
import { ToastService } from '../../services/toast.service';
import { Product } from '../../models/admin.models';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-review-popup',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './review-popup.component.html',
  styleUrls: ['./review-popup.component.scss']
})
export class ReviewPopupComponent {
  private fb = inject(FormBuilder);
  private reviewService = inject(ReviewService);
  private toastService = inject(ToastService);

  @Input() product!: Product;
  @Input() userName!: string;
  @Output() close = new EventEmitter<boolean>();
  @Output() submitted = new EventEmitter<any>();

  reviewForm: FormGroup;
  isSubmitting = false;
  hoverRating = 0;

  constructor() {
    this.reviewForm = this.fb.group({
      rating: [0, [Validators.required, Validators.min(1), Validators.max(5)]],
      comment: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  setRating(rating: number) {
    this.reviewForm.patchValue({ rating });
  }

  setHoverRating(rating: number) {
    this.hoverRating = rating;
  }

  async submitReview() {
    if (this.reviewForm.invalid || this.isSubmitting) {
      this.reviewForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    const reviewData = {
      productId: this.product.id,
      productName: this.product.name,
      userName: this.userName,
      rating: this.reviewForm.value.rating,
      comment: this.reviewForm.value.comment,
      date: new Date().toISOString(),
      isApproved: false // Admin will approve later
    };

    this.reviewService.submitReview(reviewData)
      .pipe(finalize(() => this.isSubmitting = false))
      .subscribe({
        next: (res) => {
          this.submitted.emit(res);
          this.closePopup();
        },
        error: (err) => {
          console.error('Error submitting review:', err);
          this.toastService.error('Failed to submit review. Please try again.');
        }
      });
  }

  closePopup() {
    this.close.emit(true);
  }
}
